import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { useDecision } from '@optimizely/react-sdk';

import Card from '@starbucks-web/pattern-library/lib/components/card';
import Heading from '@starbucks-web/pattern-library/lib/components/heading';

import { FEATURES } from 'shared/app/components/optimizely/optimizely-keys';
import { mobileAppsLandingPageUrlSelector } from '../../../../rewards/app/state/selectors';

import { sharedNotificationMessages } from '../../messages/notifications';
import { paymentMessages } from '../../messages/payments';

const EmergencySpfOutage = () => {
  const [showOutageBannerDecision] = useDecision(FEATURES.EMERGENCY_SPF_OUTAGE);
  const mobileAppsLandingPageUrl = useSelector(
    mobileAppsLandingPageUrlSelector
  );
  const storeLocatorLink = '/store-locator';

  return showOutageBannerDecision?.enabled ? (
    <Card containerClasses="bg-red mb3" contentClasses="p4">
      <Heading className="color-textWhite" size="lg" tagName="h2">
        <FormattedMessage
          {...sharedNotificationMessages.emergencyOutageHeading}
        />
      </Heading>
      <p className="color-textWhite">
        <FormattedMessage
          {...paymentMessages.emergencySpfOutageBody}
          values={{
            storeLocator: (content) => <a href={storeLocatorLink}>{content}</a>,
            appDownload: (content) => (
              <a href={mobileAppsLandingPageUrl}>{content}</a>
            ),
          }}
        />
      </p>
    </Card>
  ) : null;
};

export default EmergencySpfOutage;
